import { Injectable } from '@angular/core';
import Project from '../model/Project';
import AbstractRestService from './abstract-rest-service.interface';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectStore extends AbstractRestService<Project> {
  constructor(http: HttpClient, env: EnvironmentService) {
    super(http, env.projectsFetchUrl);
  }
}
